/* Guimanos Atelier — theme scripts (no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var routes = (window.theme && window.theme.routes) || {};
  var root = (routes.root || '/').replace(/\/?$/, '/'); // root_url has no trailing slash on non-default locales (e.g. /en)
  // Translated UI strings rendered in layout/theme.liquid (window.theme.strings); PT literal is the fallback.
  function str(key, fallback) {
    var s = window.theme && window.theme.strings;
    return (s && s[key]) || fallback;
  }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  /* ------------------------------------------------------------------ Drawers */
  var overlay = $('[data-overlay]');
  var openDrawer = null;
  var lastFocus = null;

  function open(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) close(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('is-locked');
    openDrawer = el;
    var focusTarget = $('input[type="search"]', el) || $('[data-close]', el) || el;
    setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 50);
  }
  function close(keepOverlay) {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    openDrawer = null;
    if (!keepOverlay) {
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('is-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  }
  window.themeDrawer = { open: open, close: close };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) { close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); closeLightbox(); }
  });

  /* ------------------------------------------------------------------ Header */
  var header = $('[data-header]');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ------------------------------------------------------------------ Hero video toggle */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-toggle]');
    if (!btn) return;
    var hero = btn.closest('[data-hero]');
    var videos = $$('video', hero);
    var paused = btn.classList.toggle('is-paused');
    videos.forEach(function (v) {
      v.dataset.userPaused = paused ? '1' : '';
      if (paused) { v.pause(); } else { tryPlay(v); }
    });
    btn.setAttribute('aria-label', paused ? str('playVideo', 'Reproduzir vídeo') : str('pauseVideo', 'Pausar vídeo'));
  });

  /* ------------------------------------------------------------------   /* ------------------------------------------------------------------ Autoplay videos
     Keeps native autoplay/muted/loop/playsinline; JS only pauses off-screen videos
     and recovers playback. Play button only shows on a real block (NotAllowedError). */
  var VIDEO_HOST = '.gallery__item, .pgrid__promo, .split__tile, .media-fill';
  function playButtonFor(v) {
    var host = v.closest('[data-hero]') ? null : (v.closest(VIDEO_HOST) || v.parentNode);
    if (!host) return null;
    var b = host.querySelector(':scope > .video-play');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'video-play';
      b.setAttribute('aria-label', str('playVideo', 'Reproduzir vídeo'));
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(b);
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        v.dataset.userPaused = '';
        tryPlay(v, true);
      });
    }
    return b;
  }
  function setBlocked(v, blocked) {
    v.dataset.blocked = blocked ? '1' : '';
    var hero = v.closest('[data-hero]');
    if (hero) {
      var tb = $('[data-video-toggle]', hero);
      if (tb) {
        tb.classList.toggle('is-paused', blocked);
        tb.setAttribute('aria-label', blocked ? str('playVideo', 'Reproduzir vídeo') : str('pauseVideo', 'Pausar vídeo'));
      }
      return;
    }
    if (blocked) {
      var b = playButtonFor(v);
      if (b) b.hidden = false;
    } else {
      var host = v.closest(VIDEO_HOST);
      var pb = host && host.querySelector(':scope > .video-play');
      if (pb) pb.hidden = true;
    }
  }
  function tryPlay(v, fromUser) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    if (v.readyState === 0 && v.preload === 'none') v.preload = 'metadata';
    var p;
    try { p = v.play(); } catch (err) { p = null; }
    if (p && typeof p.then === 'function') {
      p.then(function () { setBlocked(v, false); }, function (err) {
        if (err && err.name === 'AbortError') return; // interrupted, not a block
        setBlocked(v, true);
      });
    } else if (v.paused) { setBlocked(v, true); } else { setBlocked(v, false); }
  }
  function isShown(v) { return v.offsetParent !== null || v.getClientRects().length > 0; }
  function inView(v) {
    var r = v.getBoundingClientRect();
    return isShown(v) && r.bottom > 0 && r.top < window.innerHeight;
  }
  var autoVideos = $$('video[autoplay], video.media-fill__video, video.gallery__video');
  autoVideos.forEach(function (v) {
    v.muted = true; v.defaultMuted = true;
    v.addEventListener('playing', function () { setBlocked(v, false); });
    v.addEventListener('loadeddata', function () {
      if (v.paused && !v.dataset.userPaused && !v.dataset.blocked && inView(v)) tryPlay(v);
    });
  });
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && isShown(v)) {
          if (!v.dataset.userPaused && v.paused) tryPlay(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    autoVideos.forEach(function (v) { vio.observe(v); });
  } else {
    autoVideos.forEach(function (v) { if (isShown(v)) tryPlay(v); });
  }
  function resumeVisible(fromGesture) {
    autoVideos.forEach(function (v) {
      if (!v.paused || v.dataset.userPaused || !inView(v)) return;
      if (v.dataset.blocked && !fromGesture) return;
      tryPlay(v, fromGesture);
    });
  }
  ['touchend', 'pointerup', 'click', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, function () { resumeVisible(true); }, { passive: true });
  });
  var resumeQueued = false;
  window.addEventListener('scroll', function () {
    if (resumeQueued) return;
    resumeQueued = true;
    requestAnimationFrame(function () { resumeQueued = false; resumeVisible(false); });
  }, { passive: true });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) resumeVisible(false); });
  window.addEventListener('pageshow', function () { resumeVisible(false); });
  /* ------------------------------------------------------------------ Sliders */
  function initSliders(ctx) {
    $$('[data-slider-track]', ctx).forEach(function (track) {
      if (track.dataset.ready) return;
      track.dataset.ready = '1';
      var section = track.closest('section');
      var step = function (dir) {
        var slide = track.firstElementChild;
        if (!slide) return;
        var w = slide.getBoundingClientRect().width + 12;
        track.scrollBy({ left: dir * w * Math.max(1, Math.floor(track.clientWidth / w)), behavior: 'smooth' });
      };
      var prev = $('[data-slider-prev]', section);
      var next = $('[data-slider-next]', section);
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }
  initSliders(document);

  /* ------------------------------------------------------------------ Cart */
  var cartDrawer = $('[data-cart-drawer]');

  function refreshCart(openAfter) {
    return fetch(root + '?sections=cart-drawer-content')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-content'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('.shopify-section') ? tmp.querySelector('.shopify-section').innerHTML : tmp.innerHTML;
          $$('[data-cart-content]').forEach(function (c) { c.innerHTML = inner; });
        }
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (openAfter && cartDrawer && window.theme.cartType === 'drawer') open('cart-drawer');
        return cart;
      });
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (window.theme.cartType !== 'drawer') { window.location.href = routes.cart; return; }
        return refreshCart(true);
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  // Header cart icon opens drawer
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('[data-open-cart]');
    if (cartLink && cartDrawer && window.theme.cartType === 'drawer') { e.preventDefault(); open('cart-drawer'); }
  });

  // Quick add from cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-quick-add'), 1, btn).catch(function (err) {
      alert((err && (err.description || err.message)) || str('addError', 'Não foi possível adicionar ao saco.'));
    });
  });

  // Line quantity changes
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    var line = btn.closest('[data-key]');
    if (!line) return;
    line.classList.add('is-loading');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: Number(btn.getAttribute('data-line-change')) })
    }).then(function () { return refreshCart(false); })
      .catch(function () { line.classList.remove('is-loading'); });
  });

  // Cart note (debounced)
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer);
    var note = e.target.value;
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note }) });
    }, 500);
  });

  /* ------------------------------------------------------------------ Product page */
  $$('[data-product]').forEach(function (section) {
    var form = $('[data-product-form]', section);
    var picker = $('[data-variant-picker]', section);
    var json = $('[data-variants-json]', section);
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-btn]', section);
    var addLabel = $('[data-add-label]', section);
    var priceEl = $('[data-product-price]', section);
    var stickyBar = $('[data-sticky-atc]', section);

    function selectedOptions() {
      return $$('.variants__group', picker).map(function (g) {
        var checked = $('input:checked', g);
        return checked ? checked.value : null;
      });
    }

    function updateAvailability() {
      if (!picker) return;
      var groups = $$('.variants__group', picker);
      var sel = selectedOptions();
      groups.forEach(function (g, gi) {
        $$('label', g).forEach(function (label) {
          var input = $('input', label);
          var test = sel.slice();
          test[gi] = input.value;
          var match = variants.some(function (v) {
            return v.available && v.options.every(function (o, oi) { return test[oi] === null || o === test[oi]; });
          });
          label.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function onChange() {
      var sel = selectedOptions();
      $$('.variants__group', picker).forEach(function (g, gi) {
        var out = $('[data-option-value]', g);
        if (out) out.textContent = sel[gi] || '';
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
      updateAvailability();
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = str('unavailable', 'Indisponível');
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? str('addToBag', 'Adicionar ao saco') : str('soldOut', 'Esgotado');
      if (priceEl) {
        var html = variant.compare_at_price > variant.price
          ? '<span class="price"><span class="price__sale">' + formatMoney(variant.price) + '</span><s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s></span>'
          : '<span class="price"><span>' + formatMoney(variant.price) + '</span></span>';
        priceEl.innerHTML = html;
      }
      if (stickyBar) {
        var sv = $('[data-sticky-variant]', stickyBar);
        var sp = $('[data-sticky-price]', stickyBar);
        var sb = $('[data-sticky-add]', stickyBar);
        if (sv) sv.textContent = variant.title;
        if (sp) sp.innerHTML = formatMoney(variant.price);
        if (sb) sb.disabled = !variant.available;
      }
      if (variant.featured_media) goToMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (picker) {
      picker.addEventListener('change', onChange);
      updateAvailability();
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = $('[data-form-error]', section);
        if (err) err.hidden = true;
        var qtyInput = $('input[name="quantity"]', form);
        addToCart(idInput.value, qtyInput ? Number(qtyInput.value) : 1, addBtn).catch(function (j) {
          if (err) { err.textContent = (j && (j.description || j.message)) || str('error', 'Ocorreu um erro.'); err.hidden = false; }
        });
      });
    }

    // Quantity steppers
    $$('[data-qty]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input', b.parentNode);
        input.value = Math.max(1, Number(input.value) + Number(b.getAttribute('data-qty')));
      });
    });

    // Gallery
    var track = $('[data-gallery-track]', section);
    var items = track ? $$('.gallery__item', track) : [];
    var thumbs = $$('[data-thumb]', section);
    var dots = $$('.gallery__dot', section);
    var isSliderLayout = !!section.querySelector('.product__grid--slider');
    var mq = window.matchMedia('(max-width: 989px)');

    function setActive(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      if (isSliderLayout) items.forEach(function (it, ii) { it.classList.toggle('is-active', ii === i); });
    }
    function goTo(i) {
      var item = items[i];
      if (!item) return;
      setActive(i);
      if (mq.matches) {
        track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else if (!isSliderLayout) {
        var top = item.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0) - 12;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }
    function goToMedia(mediaId) {
      var idx = items.findIndex(function (it) { return it.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    }
    if (isSliderLayout) setActive(0);
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-thumb'))); }); });

    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        if (!mq.matches) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      if ('IntersectionObserver' in window && !isSliderLayout) {
        var io = new IntersectionObserver(function (entries) {
          if (mq.matches) return;
          entries.forEach(function (en) {
            if (en.isIntersecting) setActive(Number(en.target.getAttribute('data-index')));
          });
        }, { rootMargin: '-45% 0px -45% 0px' });
        items.forEach(function (it) { io.observe(it); });
      }
    }

    // Lightbox
    var lightbox = $('[data-lightbox]', section);
    $$('[data-zoom]', section).forEach(function (z) {
      z.addEventListener('click', function () {
        if (!lightbox) return;
        $('[data-lightbox-img]', lightbox).src = z.getAttribute('data-zoom');
        lightbox.hidden = false;
        document.body.classList.add('is-locked');
      });
    });
    if (lightbox) lightbox.addEventListener('click', closeLightbox);

    // Sticky add-to-bag: visible when main button is out of view
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e0 = entries[0];
        var past = !e0.isIntersecting && e0.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', past);
        stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(addBtn);
    }

    // Share
    $$('[data-share]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-share');
        if (navigator.share) { navigator.share({ title: b.getAttribute('data-share-title'), url: url }).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () {
          var done = b.parentNode.querySelector('.share__done');
          if (done) { done.hidden = false; setTimeout(function () { done.hidden = true; }, 2000); }
        });
      });
    });

    // Recently viewed: store this product
    try {
      var handle = (section.getAttribute('data-url') || '').split('/products/')[1];
      if (handle) {
        handle = handle.split('?')[0];
        var list = JSON.parse(localStorage.getItem('gm_recent') || '[]').filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem('gm_recent', JSON.stringify(list.slice(0, 16)));
      }
    } catch (err) { /* storage unavailable */ }
  });

  function closeLightbox() {
    var lb = $('[data-lightbox]:not([hidden])');
    if (!lb) return;
    lb.hidden = true;
    document.body.classList.remove('is-locked');
  }

  /* ------------------------------------------------------------------ Recommendations */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-slider-track]');
        var track = $('[data-slider-track]', el);
        if (fresh && track && fresh.children.length) {
          track.innerHTML = fresh.innerHTML;
          el.classList.add('has-items');
          initSliders(el);
        }
      }).catch(function () {});
  });

  /* ------------------------------------------------------------------ Recently viewed */
  $$('[data-recently-viewed]').forEach(function (el) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('gm_recent') || '[]'); } catch (e) { return; }
    var current = el.getAttribute('data-current');
    var limit = Number(el.getAttribute('data-limit')) || 8;
    list = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (!list.length) return;
    var track = $('[data-slider-track]', el);
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).map(function (c) { return '<div class="pslider__slide">' + c + '</div>'; }).join('');
      if (html) { track.innerHTML = html; el.classList.add('has-items'); initSliders(el); }
    });
  });

  /* ------------------------------------------------------------------ Collection */
  $$('[data-collection]').forEach(function (section) {
    var grid = $('[data-grid]', section);
    // Column toggle (remembered per browser)
    var colBtns = $$('[data-cols]', section);
    function setCols(mode) {
      grid.classList.toggle('is-large', mode === 'large');
      grid.classList.toggle('is-small', mode === 'small');
      colBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cols') === mode); });
      try { localStorage.setItem('gm_cols', mode); } catch (e) {}
    }
    var saved = 'small';
    try { saved = localStorage.getItem('gm_cols') || 'small'; } catch (e) {}
    setCols(saved);
    colBtns.forEach(function (b) { b.addEventListener('click', function () { setCols(b.getAttribute('data-cols')); }); });

    // Load more
    section.addEventListener('click', function (e) {
      var more = e.target.closest('[data-load-more]');
      if (!more) return;
      e.preventDefault();
      more.classList.add('is-loading');
      more.textContent = str('loading', 'A carregar…');
      var loadedUrl = more.href;
      fetch(loadedUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-grid]');
        if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
        var newMore = doc.querySelector('[data-load-more]');
        var newCount = doc.querySelector('[data-loadmore-count]');
        var count = $('[data-loadmore-count]', section);
        if (count && newCount) count.textContent = newCount.textContent;
        if (newMore) { more.href = newMore.href; more.textContent = str('loadMore', 'Carregar mais'); more.classList.remove('is-loading'); }
        else more.remove();
        window.history.replaceState({}, '', loadedUrl);
      });
    });
  });

  /* ------------------------------------------------------------------ Predictive search */
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  if (searchInput && searchResults && routes.search) {
    var initial = searchResults.innerHTML;
    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (!q) { searchResults.innerHTML = initial; return; }
      t = setTimeout(function () {
        fetch(routes.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=10&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var inner = tmp.querySelector('.shopify-section');
            searchResults.innerHTML = inner ? inner.innerHTML : html;
          });
      }, 250);
    });
  }

  /* ------------------------------------------------------------------ Login: recover */
  $$('[data-recover-toggle]').forEach(function (a) {
    a.addEventListener('click', function () { setTimeout(function () { var r = document.getElementById('recover'); if (r) r.scrollIntoView(); }, 0); });
  });
})();
